import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { InboundEmail } from '../api/models';
import { notification } from 'antd';
import APIClient from '../api/api';
import EmailDetailContent from '../components/EmailDetailContent';

const EmailView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState<InboundEmail>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    setEmail(undefined);
    APIClient.getEmail(parseInt(id))
      .then(setEmail)
      .catch(() => notification.error({ message: 'Failed to load email.' }))
      .finally(() => setLoading(false));
  }, [id]);

  const headerActions = (
    <button
      type="button"
      onClick={() => navigate(-1)}
      className="px-2.5 py-1 rounded-md border border-border bg-panel text-[12px] text-text-3 hover:bg-bg-elevated hover:text-text cursor-pointer"
    >
      ← Back
    </button>
  );

  return (
    <div className="flex flex-col h-full bg-panel">
      {loading && !email && (
        <div className="px-6 py-12 text-center text-text-3 text-[12.5px]">Loading…</div>
      )}
      {email && (
        <EmailDetailContent
          email={email}
          headerActions={headerActions}
        />
      )}
    </div>
  );
};

export default EmailView;
